import React, { useEffect, useRef, useState, useMemo } from 'react'
import { useStoresPinsToFitInView, useStores } from '../stores.context'
import {
  GoogleApiWrapper,
  Map,
  Marker as M,
  InfoWindow as IWindow,
} from 'google-maps-react' // TODO: Change the library
import styled, { css } from 'styled-components'
import { SingleStore, StoreLabels } from '../stores.props'
import { useLocalLabels } from '@sentecacommerce-theme/lib'

// >:((
const Marker: any = M
const InfoWindow: any = IWindow

const MapComponent = ({ google, pinIcon, fullWidth }: any) => {
  const [selectedPin, setSelectedPin] = useState<any>(null)
  const refMap = useRef<any>(null)
  const labels = useLocalLabels<StoreLabels>()

  const stores = useStores()

  const pinsToFitInMap = useStoresPinsToFitInView()

  const mapStyles = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  }

  /**
   * Center the map to the current pins
   */
  useEffect(() => {
    const bounds = new google.maps.LatLngBounds()

    pinsToFitInMap.forEach((pin) => {
      bounds.extend(pin)
    })
    if (!refMap.current) return

    const map = (refMap.current as any)?.map

    map.fitBounds(bounds)

    // set min zoom
    map.setZoom(Math.min(map.getZoom(), 14))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinsToFitInMap])

  const onMarkerClick = (store: any) => (_: any, marker: any) => {
    setSelectedPin({
      marker,
      store,
    })
  }

  const hideInfoWindow = () => {
    setSelectedPin(null)
  }

  const selectedStore = selectedPin?.store as SingleStore
  const selectedMarker = selectedPin?.marker

  // memo markers to prevent unnecessary markers initialization
  const markers = useMemo(() => {
    return stores.map((store) => {
      const pin = {
        lat: +store.latitude,
        lng: +store.longitude,
      }

      return (
        <Marker
          key={`Marker__${pin.lat}x${pin.lng}`}
          position={pin}
          icon={pinIcon}
          onClick={onMarkerClick(store)}
        />
      )
    })
  }, [stores, pinIcon])

  return (
    <MapContainer fullWidth={fullWidth}>
      <Map
        google={google}
        style={mapStyles}
        containerStyle={mapStyles}
        ref={refMap}
        initialCenter={{ lat: 42.7339, lng: 25.4858 }}
      >
        {markers}

        <InfoWindow
          marker={selectedMarker}
          onClose={hideInfoWindow}
          visible={Boolean(selectedMarker)}
        >
          {selectedStore && (
            <InfoWindowContentWrapper>
              <InfoWindowText>{selectedStore.name}</InfoWindowText>

              <InfoWindowText>
                <strong>{labels?.phoneLabel}:</strong>{' '}
                <a href={`tel:${selectedStore.phoneNumber}`}>
                  {selectedStore.phoneNumber}
                </a>
              </InfoWindowText>
              {selectedStore.email && (
                <InfoWindowText>
                  <strong>{labels?.emailLabel}:</strong>{' '}
                  <a href={`mailto:${selectedStore.email}`}>
                    {selectedStore.email}
                  </a>
                </InfoWindowText>
              )}
            </InfoWindowContentWrapper>
          )}
        </InfoWindow>
      </Map>
    </MapContainer>
  )
}

export const StoresMap = GoogleApiWrapper({
  apiKey: '',
})(MapComponent)

const InfoWindowContentWrapper = styled.div.attrs({
  className: 'p-3',
})`
  min-width: 14rem;
  min-height: 4rem;
`

const InfoWindowText = styled.p.attrs({
  className: 'pb-2',
})`
  color: ${({ theme }) => theme.palette?.greyTitle};

  & a {
    &:hover {
      text-decoration: underline;
    }
  }
`

const MapContainer = styled.div<{ fullWidth?: boolean }>`
  width: 100%;
  ${(props) =>
    props.fullWidth
      ? css`
          height: calc(100vh - 6rem);
          position: absolute;
        `
      : css`
          padding-bottom: 100%;
          position: relative;
        `}
`
